

module.exports = __webpack_require__.stylable.create(
    "TimeRenderer3248474387",
    {"classes":{"root":"TimeRenderer3248474387__root","TimeRenderer":"TimeRenderer3248474387__TimeRenderer"},"vars":{},"stVars":{"DefaultFont":"\"{theme: 'Body-M', size: '14px', lineHeight: '14px'}\"","TimeColor":"\"fallback(color(--eventTimeColor), fallback(color(--runningTextColor), color(color-4)))\"","TimeFont":"\"fallback(font(--eventTimeFont), font({theme: 'Body-M', size: '14px', lineHeight: '14px'}))\"","NotCurrentFontColor":"\"fallback(color(--notCurrentFontColor), fallback(color(--datesColor), color(color-4)))\"","Mobile_TimeFontSize":"'\"unit(fallback(--mobile_monthlyEventTimeFontSize, 12), px)\"'"},"keyframes":{}},
    "",
    1,
    "TimeRenderer3248474387",
    null
);
